<template>
  <main v-bind="dKey('pageid', pageName, pageId)">
    <section class="prev-page-section" style="background-image:url(/static-assets/img/industry-img.jpg);">
      <div class="container">
        <div v-bind="dKey('inFTitle')" class="grey-title-block resp-number">{{info.inFTitle}}</div>
      </div>
    </section>
    <section id="food-industry" class="food-industry-section industry-page change-default">
      <div class="container">
        <span v-bind="dKey('inUpTitle')" class="section-title">{{info.inUpTitle}}</span>
        <h3 v-bind="dKey('inTitle')">{{info.inTitle}}</h3>
      </div>
      <div class="position-relative">
        <div class="container">
          <div class="row d-flex">
            <div class="col-6 industry-text-wrapper">
              <div class="industry-text">
                <div v-bind="dKey('inText1')" v-html="info.inText1"></div>
                <h5 v-bind="dKey('inTitle2')">{{info.inTitle2}}</h5>
                <div v-bind="dKey('inList2')" v-html="info.inList2"></div>
                <div v-bind="dKey('inText2')" v-html="info.inText2"></div>
              </div>
            </div>
            <div class="col-6 industry-img-wrapper">
              <div>
                <img src="/static-assets/img/food-ind-img.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="diy-logistic" class="building-section industry-page img-left-side change-default">
      <div class="container">
        <span class="section-title"></span>
        <h3 v-bind="dKey('inSudTitle')">{{info.inSudTitle}}</h3>
      </div>
      <div class="position-relative">
        <div class="container">
          <div class="row d-flex">
            <div class="col-6 industry-text-wrapper">
              <div class="food-industry-text">
                <div v-bind="dKey('inSudText1')" v-html="info.inSudText1"></div>
                <h5 v-bind="dKey('inSudTitle2')">{{info.inSudTitle2}}</h5>
                <div v-bind="dKey('inSudList2')" v-html="info.inSudList2"></div>
                <div v-bind="dKey('inSudText2')" v-html="info.inSudText2"></div>
              </div>
            </div>
            <div class="col-6 industry-img-wrapper">
              <div>
                <img src="/static-assets/img/building-img.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="fmcg-logistics" class="train-section industry-page change-default">
      <div class="container">
        <span class="section-title"></span>
        <h3 v-bind="dKey('inFMCGTitle')">{{info.inFMCGTitle}}</h3>
      </div>
      <div class="position-relative">
        <div class="container">
          <div class="row d-flex">
          <div class="col-6 industry-text-wrapper">
            <div class="industry-text">
              <div v-bind="dKey('inFMCGText1')" v-html="info.inFMCGText1"></div>
              <h5 v-bind="dKey('inFMCGTitle2')">{{info.inFMCGTitle2}}</h5>
              <div v-bind="dKey('inFMCGList2')" v-html="info.inFMCGList2"></div>
              <div v-bind="dKey('inFMCGText3')" v-html="info.inFMCGText3"></div>
            </div>
          </div>
          <div class="col-6 industry-img-wrapper">
            <div>
              <img src="/static-assets/img/train-img.jpg" alt="">
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    <section class="quote-section">
      <div class="container">
        <div class="row">
          <div class="col-6 col-xl-4 quote-img position-static">
            <div style="background-image: url(/static-assets/img/truck-img.png);"></div>
          </div>
          <div class="col-10 col-sm-6 col-xl-8 quote-text">
            <h4 v-bind="dKey('inANTTITLE')">{{info.inANTTITLE}}</h4>
          </div>
        </div>
      </div>
    </section>
    <section id="automotive-industry" class="our-excellence-section industry-page">
      <div class="container">
        <span class="section-title"></span>
        <h3 v-bind="dKey('inAutoTitle')">{{info.inAutoTitle}}</h3>
        <p v-bind="dKey('inAutoText')" v-html="info.inAutoText"></p>
        <h5 v-bind="dKey('inAutoSubTitle')">{{info.inAutoSubTitle}}</h5>
        <div class="row our-excellence-wrapper">
          <div class="col-3">
            <div class="our-excellence-overview">
              <div class="for-borders">
                <span class="gradient-words">01</span>
                <div class="row our-excellence-content">
                <div class="col-4 excellence-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="94" height="38" viewBox="0 0 94 38"><defs>
                    <path id="m3sva" d="M214.167 4626.25h6.267v3.168h-6.267zm54.835-3.166v12.825c.008 2.463-1.477 4.68-3.744 5.588l-5.074 2.057a1.553 1.553 0 0 1-.583.113h-.562a9.418 9.418 0 0 1-5.74 5.802c-4.882 1.728-10.226-.869-11.937-5.802h-41.857a9.416 9.416 0 0 1-5.741 5.802c-4.881 1.728-10.225-.869-11.936-5.802h-5.261a1.575 1.575 0 0 1-1.567-1.583v-9.402a7.243 7.243 0 0 1 3.594-6.259 36.72 36.72 0 0 1 17.915-4.907l5.37-2.962a52.823 52.823 0 0 1 25.43-6.553h1.848a52.297 52.297 0 0 1 21.827 4.75 53.573 53.573 0 0 1 6.031 3.23l10.642 1.536c.772.112 1.345.78 1.345 1.567zm-72.069 17.417c.001-3.01-2.094-5.605-5.011-6.207-3.391-.7-6.702 1.51-7.395 4.937-.693 3.427 1.494 6.773 4.885 7.473 3.391.7 6.702-1.51 7.395-4.936.084-.418.126-.842.126-1.267zm28.201-15.833h-28.2a33.598 33.598 0 0 0-16.784 4.504 4.058 4.058 0 0 0-2.017 3.51v7.82h3.133c0-5.248 4.21-9.501 9.4-9.501 5.193 0 9.4 4.253 9.4 9.5h25.068zm0-9.43a49.688 49.688 0 0 0-21.754 6.096l-.302.167h22.056zm3.133 6.263h16.586l2.736-2.764a49.134 49.134 0 0 0-18.435-3.57h-.887zm28.201 19c0-3.01-2.094-5.605-5.012-6.207-3.39-.7-6.702 1.51-7.395 4.937-.693 3.427 1.495 6.773 4.885 7.473 3.392.7 6.702-1.51 7.395-4.936a6.41 6.41 0 0 0 .127-1.267zm9.4-16.045l-9.622-1.388a1.569 1.569 0 0 1-.608-.224 49.889 49.889 0 0 0-4.967-2.746l-4.062 4.105a1.555 1.555 0 0 1-1.108.464h-17.233v15.832h12.538c.005-5.245 4.21-9.495 9.4-9.5.33 0 .643.017.956.049.116.01.227.036.343.052.196.029.394.05.586.09.12.026.235.064.354.092.182.046.365.086.544.142.133.042.235.086.392.143.156.057.336.118.47.174.133.057.246.119.39.189.144.069.302.141.429.209s.236.137.371.226c.135.09.276.163.401.247.125.084.245.18.364.271.118.09.24.17.358.272.12.103.235.22.344.317.107.098.214.186.322.296.108.111.216.246.313.345.098.1.191.195.292.317.1.122.197.26.283.377.086.117.17.22.26.35.088.13.174.274.245.4.07.127.153.243.227.378.073.137.138.284.204.418.065.136.14.265.194.407.055.143.103.292.157.436.053.144.11.285.156.432.047.148.078.3.12.45.04.15.086.31.117.454.031.144.05.303.075.461.025.158.056.317.072.475.016.159.019.33.028.475.01.145.028.29.028.435l4.494-1.823a2.835 2.835 0 0 0 1.774-2.646v-6.49h-4.7v-3.169h4.7z"/></defs><g><g transform="translate(-175 -4612)"><use fill="#fff" xlink:href="#m3sva"/></g></g>
                  </svg>
                </div>
                <div class="col-8 excellence-text">
                  <p v-bind="dKey('inAutoArray#0')" class="m-0">{{getInAuto(0)}}</p>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="our-excellence-overview">
              <div class="for-borders">
                <span class="gradient-words">02</span>
                <div class="row our-excellence-content">
                <div class="col-4 excellence-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="91" height="65" viewBox="0 0 91 65"><defs>
                    <path id="af1ba" d="M586.233 4663c-4.502 0-8.25-3.274-8.973-7.559h-10.743a1.513 1.513 0 0 1-1.517-1.51v-48.373c0-.835.68-1.512 1.517-1.512h57.633c.839 0 1.517.677 1.517 1.512v9.07h15.166c.516 0 .997.26 1.276.693l13.65 21.163a1.5 1.5 0 0 1 .24.818v16.628c0 .836-.677 1.511-1.516 1.511h-7.71c-.723 4.285-4.47 7.558-8.973 7.558-4.502 0-8.25-3.273-8.974-7.558h-33.619c-.724 4.285-4.471 7.558-8.974 7.558zm0-18.14c4.502 0 8.25 3.273 8.974 7.558h27.426v-3.024H596.85v-3.022h25.783v-33.256h-51.566v-3.024h51.566v-3.023h-54.6v39.303h7.584v3.023h-7.584v3.023h9.227c.724-4.285 4.471-7.558 8.973-7.558zm6.067 9.07c0-3.335-2.721-6.047-6.067-6.047-3.345 0-6.066 2.712-6.066 6.047 0 3.334 2.72 6.046 6.066 6.046 3.346 0 6.067-2.712 6.067-6.046zm45.5-9.07c4.502 0 8.25 3.273 8.974 7.558h6.193v-3.024h-4.55v-3.022h4.55v-8.626l-.287-.444h-22.463a1.513 1.513 0 0 1-1.517-1.512v-13.605c0-.834.678-1.511 1.517-1.511h11.738l-1.95-3.023h-14.338v34.767h3.16c.723-4.285 4.471-7.558 8.973-7.558zm6.067 9.07c0-3.335-2.721-6.047-6.067-6.047s-6.067 2.712-6.067 6.047c0 3.334 2.721 6.046 6.067 6.046s6.067-2.712 6.067-6.046zm-12.134-19.651h18.997l-6.863-10.64v.058h-12.134zm-47.016 18.139h3.033v3.023h-3.033zm51.566 0h3.034v3.023h-3.034zM571.067 4598H592.3v3.023h-21.233zm-6.067 0h3.033v3.023H565z"/></defs><g><g transform="translate(-565 -4598)"><use fill="#fff" xlink:href="#af1ba"/></g></g>
                  </svg>
                </div>
                <div class="col-8 excellence-text">
                  <p v-bind="dKey('inAutoArray#1')" class="m-0">{{getInAuto(1)}}</p>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="our-excellence-overview">
              <div class="for-borders">
                <span class="gradient-words">03</span>
                <div class="row our-excellence-content">
                <div class="col-4 excellence-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="74" height="74" viewBox="0 0 74 74"><defs>
                    <path id="gx1ka" d="M1029 4644.128c0 13.162-10.709 23.87-23.871 23.87-11.099 0-20.425-7.623-23.086-17.902h-19.882a7.168 7.168 0 0 1-7.161-7.161v-5.968a7.159 7.159 0 0 1 3.21-5.968 7.16 7.16 0 0 1-3.21-5.968v-5.968a7.157 7.157 0 0 1 3.21-5.967 7.161 7.161 0 0 1-3.21-5.968v-5.968a7.168 7.168 0 0 1 7.16-7.161h41.775a7.169 7.169 0 0 1 7.162 7.16v5.969a7.158 7.158 0 0 1-3.21 5.968 7.16 7.16 0 0 1 3.21 5.967v1.98c10.279 2.66 17.903 11.986 17.903 23.085zm-10.04-13.129a19.025 19.025 0 0 1 4.98 9.963l2.646 2.646a21.349 21.349 0 0 0-4.49-12.609zm-11.137-8.168l-2.224 2.224a18.965 18.965 0 0 1 10.62 3.556h3.73a21.396 21.396 0 0 0-12.126-5.78zm-3.888-8.542h-3.148l-4.297 3.581h12.05c-.533-2.053-2.387-3.581-4.605-3.581zm-25.497-5.967h-10.593l4.296 3.58h10.594zm8.026 3.58h10.594l-4.297-3.58h-10.594zm-4.297 5.968h10.594l4.297-3.581h-10.594zm26.373-9.548h-12.05l4.297 3.58h3.148c2.218 0 4.071-1.528 4.605-3.58zm-22.076-11.936l-4.297 3.58h10.594l4.297-3.58zm-14.323 0l-4.296 3.58h10.593l4.297-3.58zm-14.585 3.58h6.56l4.297-3.58h-6.252c-2.218 0-4.071 1.527-4.605 3.58zm-.17 5.968h51.324v-3.58h-3.581v-2.388h3.411c-.533-2.053-2.387-3.58-4.604-3.58h-3.149l-4.297 3.58h1.478v2.388h-40.581zm4.775 5.968h6.252l-4.297-3.58h-6.56c.534 2.052 2.387 3.58 4.605 3.58zm-4.605 5.968h6.56l4.297-3.581h-6.252c-2.218 0-4.071 1.528-4.605 3.581zm-.17 5.968h35.23c3.645-2.256 7.922-3.581 12.513-3.581 1.22 0 2.41.12 3.58.298v-.298h-31.032v-2.387h.761l4.298-3.581H972.14l-7.16 5.968h-7.594zM992 4627.16v3.136a19.028 19.028 0 0 1 9.963-4.98l2.646-2.645a21.35 21.35 0 0 0-12.61 4.49zm-5.774 2.446a23.98 23.98 0 0 1 3.167-3.382h-7.226zm-7.787-3.382h-10.594l4.296 3.58h10.594zm5.394 15.209l2.223 2.223a18.958 18.958 0 0 1 3.557-10.62v-3.728a21.395 21.395 0 0 0-5.78 12.125zm-21.672-11.629h6.252l-4.297-3.58h-6.56c.534 2.052 2.387 3.58 4.605 3.58zm-4.605 5.968h6.56l4.297-3.58h-6.252c-2.218 0-4.071 1.527-4.605 3.58zm10.857 11.936l-4.297-3.582h-6.56c.534 2.053 2.387 3.582 4.605 3.582zm9.264-9.55v-2.386h5.12a23.789 23.789 0 0 1 1.69-3.581h-12.346l-4.296 3.58h7.445v2.388h-17.903v3.58h17.903v2.388h-7.445l4.296 3.58h9.415c-.178-1.17-.298-2.36-.298-3.58 0-2.064.291-4.057.785-5.968zm13.621 19.098a19.024 19.024 0 0 1-4.98-9.963l-2.646-2.646a21.347 21.347 0 0 0 4.49 12.609zm13.36 5.943a18.961 18.961 0 0 1-10.62-3.556h-3.728a21.399 21.399 0 0 0 12.125 5.78zm.471-2.362c9.214 0 16.71-7.496 16.71-16.71s-7.496-16.71-16.71-16.71-16.71 7.495-16.71 16.71c0 9.214 7.496 16.71 16.71 16.71zm13.129-2.88a19.025 19.025 0 0 1-9.963 4.981l-2.646 2.645a21.352 21.352 0 0 0 12.609-4.49zm8.167-11.136l-2.223-2.223a18.96 18.96 0 0 1-3.557 10.62v3.728a21.399 21.399 0 0 0 5.78-12.125zm-21.296 9.241c-6.582 0-11.936-5.354-11.936-11.935s5.355-11.936 11.936-11.936c6.581 0 11.936 5.355 11.936 11.936 0 6.581-5.355 11.935-11.936 11.935zm0-2.387c5.265 0 9.548-4.283 9.548-9.549 0-5.264-4.283-9.548-9.548-9.548s-9.548 4.284-9.548 9.548c0 5.266 4.283 9.55 9.548 9.55zm-4.774-53.71h2.387v2.388h-2.387zm-27.452 17.904h2.387v2.387h-2.387zm-4.726 0h2.388v2.387h-2.388zm45.704 36.044l1.592 1.778a15.488 15.488 0 0 1-10.344 3.952v-2.387c3.236 0 6.344-1.188 8.752-3.343zm-36.204-12.173h2.387v2.387h-2.387zm11.456 24.111l-1.433 1.91a31.377 31.377 0 0 1-8.608-9.93l2.093-1.148a28.976 28.976 0 0 0 7.948 9.168z"/></defs><g><g transform="translate(-955 -4594)"><use fill="#fff" xlink:href="#gx1ka"/></g></g>
                  </svg>
                </div>
                <div class="col-8 excellence-text">
                  <p v-bind="dKey('inAutoArray#2')" class="m-0">{{getInAuto(2)}}</p>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="our-excellence-overview">
              <div class="for-borders">
                <span class="gradient-words">04</span>
                <div class="row our-excellence-content">
                <div class="col-4 excellence-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70" height="69" viewBox="0 0 70 69"><defs>
                    <path id="jdcia" d="M1415 4619.75h-4.516v36.198H1415v9.05h-70v-9.05h4.516v-36.197H1345v-9.05h6.774v-6.787h11.29v6.787h33.871v-6.787h11.29v6.788H1415zm-67.742 38.46v4.525h65.484v-4.525zm60.968-2.262v-36.197h-56.452v36.197zm4.516-38.46v-4.524h-6.775v-6.787h-6.774v6.787h-38.387v-6.787h-6.774v6.787h-6.774v4.524zm-46.29-11.311h27.096v2.262h-27.097zm8.25 41.853h-20.67v-2.262h21.452v.172l1.757-4.697h-8.1l5.645-11.312h-20.754v-2.262h21.883l1.13-2.262h12.217l-1.975 2.262h18.68v2.262h-20.656l-3.952 4.525h10.398l-11.29 11.312h25.5v2.262h-27.758l-5.612 5.624zm-1.908-9.05h7.706l-2.13 5.688 7.937-7.95h-9.924l7.903-9.05h-5.846zm-18.762-40.721h6.774v2.262h-6.774zm47.42 2.262h-2.259v-2.262h2.258v-2.263h2.259v2.263h2.258v2.262h-2.258v2.262h-2.259zm-47.42 21.492h2.258v2.262h-2.258zm4.516 0h2.258v2.262h-2.258zm-4.516 29.41h2.258v2.262h-2.258zm49.678-29.41h2.258v2.262h-2.258zm-4.517 0h2.258v2.262h-2.258z"/></defs><g><g transform="translate(-1345 -4596)"><use fill="#fff" xlink:href="#jdcia"/></g></g>
                  </svg>
                </div>
                <div class="col-8 excellence-text">
                  <p v-bind="dKey('inAutoArray#3')" class="m-0">{{getInAuto(3)}}</p>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-bind="dKey('inAutoDown')" v-html="info.inAutoDown"></div>
      </div>
    </section>
    <section id="chemical-industry" class="chemical-industry-section industry-page change-default">
      <div class="container">
        <span class="section-title"></span>
        <h3 v-bind="dKey('inHimTitle')">{{info.inHimTitle}}</h3>
      </div>
      <div class="position-relative">
        <div class="container">
          <div class="row d-flex">
            <div class="col-6 industry-text-wrapper">
              <div class="industry-text">
                <h5 v-bind="dKey('inHimTitle1')">{{info.inHimTitle1}}</h5>
                <div v-bind="dKey('inHimList1')" v-html="info.inHimList1"></div>
                <div v-bind="dKey('inHimText1')" v-html="info.inHimText1"></div>
                <div v-bind="dKey('inHimBlockquote1')" v-html="info.inHimBlockquote1"></div>
                <div v-bind="dKey('inHimTextDown1')" v-html="info.inHimTextDown1"></div>
              </div>
            </div>
            <div class="col-6 industry-img-wrapper">
              <div>
                <img src="/static-assets/img/chemical-img.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="home-appliances-industry" class="house-appliances-section industry-page change-default">
      <div class="container">
        <span class="section-title"></span>
        <h3 v-bind="dKey('inBtTitle')">{{info.inBtTitle}}</h3>
        <div class="row">
          <div class="col-5 house-appliances-img">
            <div v-bind="dKey('inBtTextLeft')" v-html="info.inBtTextLeft" class="quote-text"></div>
            <div class="quote-img-house">
              <img src="/static-assets/img/delivery-img.jpg" alt="">
            </div>
          </div>
          <div class="col-6 industry-text-wrapper">
            <div v-bind="dKey('inBtTextRight')" v-html="info.inBtTextRight" class="industry-text"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="warranty-text-section">
      <div class="container">
        <div class="warranty-text-wrapper">
          <div class="big-car-img">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="519" height="270" viewBox="0 0 519 270"><defs>
              <path id="zb0wa" d="M600.793 7527c-22.66 0-41.777-15.467-47.375-36.41h-72.781c-5.598 20.943-24.716 36.41-47.375 36.41-22.66 0-41.778-15.467-47.376-36.41H283.991c-6.77 0-12.258-5.493-12.258-12.272 0-6.778 5.487-12.273 12.258-12.273h101.684c5.313-21.357 24.633-37.228 47.587-37.228 22.953 0 42.273 15.871 47.586 37.228h72.358c5.314-21.357 24.633-37.228 47.587-37.228 22.953 0 42.272 15.87 47.586 37.226h23.104v-63.294l-17.852-23.023h-95.334c-6.77 0-12.258-5.494-12.258-12.273v-85.909H283.99c-6.77 0-12.258-5.494-12.258-12.272 0-6.778 5.487-12.272 12.258-12.272h274.307c6.77 0 12.258 5.493 12.258 12.272v12.273h52.302c4.634 0 8.871 2.614 10.955 6.758l36.775 73.227-.022.011 22.86 29.477a12.299 12.299 0 0 1 2.574 7.527v79.771c0 6.778-5.488 12.272-12.259 12.272H648.17c-5.596 20.944-24.712 36.411-47.376 36.411zm24.517-49.092c0-13.536-10.996-24.545-24.517-24.545-13.52 0-24.517 11.009-24.517 24.545 0 13.537 10.996 24.546 24.517 24.546 13.52 0 24.517-11.008 24.517-24.546zm-167.532 0c0-13.536-11-24.545-24.516-24.545-13.521 0-24.517 11.009-24.517 24.545 0 13.537 10.996 24.546 24.517 24.546 13.52 0 24.516-11.008 24.516-24.546zm157.52-171.818h-44.742v49.091h69.395zm-207.372 110.046c0 6.778-5.487 12.272-12.258 12.272H209.28c-6.77 0-12.258-5.493-12.258-12.272s5.487-12.273 12.258-12.273h186.39c6.77 0 12.257 5.494 12.256 12.273zm28.195-48.273c0 6.778-5.487 12.272-12.258 12.272H189.258c-6.77 0-12.258-5.493-12.258-12.272s5.488-12.273 12.258-12.273h234.605c6.771 0 12.258 5.495 12.258 12.273zm20.022-48.273c0 6.778-5.487 12.272-12.258 12.272H209.28c-6.77 0-12.258-5.493-12.258-12.272 0-6.778 5.487-12.273 12.258-12.273h234.605c6.771 0 12.26 5.495 12.258 12.273z"/><linearGradient id="zb0wb" x1="177" x2="696" y1="7392" y2="7392" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f7844a"/><stop offset="1" stop-color="#ffad2f"/></linearGradient></defs><g><g transform="translate(-177 -7257)"><use fill="#fff" xlink:href="#zb0wa"/><use fill="url(#zb0wb)" xlink:href="#zb0wa"/></g></g>
            </svg>
          </div>
          <div class="warranty-text">
            <h4 v-bind="dKey('inLText')">{{info.inLText}}</h4>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'Industry',

  data() {
    return {
      info: {},
      pageId: 0,
      navigate: '',
      pageName: 'industry',
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })

    location.hash = this.$route.hash
  },

  created() {
    this.$root.getPage('industry', this.$root.language_id, response => {
      this.info = response.info
      this.pageId = response.pageId
    })
  },

  watch:{
    $route (to, from) {
      this.$root.getPage('industry', this.$root.language_id, response => {
        this.info = response.info
        this.pageId = response.pageId
      })
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getInAuto(key) {
      if (this.info.inAutoArray && this.info.inAutoArray[key])
        return this.info.inAutoArray[key]
      return ''
    }
  }

}

</script>
